import { CSSProperties, useContext } from 'react';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { isStaticTextComponent } from '@shared/scenes/workflows/utils';
import { ColorThemeContext, grid } from '@shared/styles';
import { API } from '@shared/types/api';

interface Props {
  component: API.StaticTextComponentFragment;
  style?: CSSProperties;
}

export function StaticTextEditField({ component, style }: Props) {
  const colors = useContext(ColorThemeContext);

  if (!isStaticTextComponent(component)) {
    return null;
  }

  return (
    <View row centerVertically style={{ ...style, paddingTop: grid(2), paddingBottom: grid(3) }}>
      <View marginRight={1}>
        <MBIconV2 name="info-i" color={colors.foregroundInactive} size={grid(3)} />
      </View>
      <Text size="body1" color={colors.foregroundActive}>
        {component.text}
      </Text>
    </View>
  );
}
